import { JobAssistApi } from '@servicetitan/financing-api-client';
import { useDependencies } from '@servicetitan/react-ioc';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { SubmittingUserStore } from '../features/application/SubmittingUserStore';

export const useTechnicianData = ({
    technicianId,
    tenantId,
    enabled = true,
}: {
    technicianId: string;
    tenantId: string;
    enabled?: boolean;
}) => {
    const [jobAssistApiClient] = useDependencies(JobAssistApi);

    const technicianResult = useQuery({
        queryKey: ['getTechnician', technicianId, tenantId],
        queryFn: () => {
            return jobAssistApiClient.getTechnician(tenantId, technicianId, Number(technicianId));
        },
        enabled: enabled && !!technicianId && !!tenantId,
    });

    const technicianData = technicianResult.data?.data;
    const { setSubmittingUser } = SubmittingUserStore.useStore();

    useEffect(() => {
        if (technicianData?.Name) {
            setSubmittingUser({
                firstName: technicianData.Name,
                lastName: technicianData.Name,
                email: technicianData.Email ?? '',
                phone: technicianData.Phone ?? '',
            });
        }
    }, [technicianData?.Name, technicianData?.Email, technicianData?.Phone, setSubmittingUser]);

    return {
        technicianResult,
        technicianData,
        name: technicianData?.Name,
        email: technicianData?.Email,
        phone: technicianData?.Phone,
        status: technicianData?.Status,
        hourlyRate: technicianData?.HourlyRate,
        isLoading: technicianResult.isLoading,
        error: technicianResult.error,
    };
};
